<!-- Basic Inputs start -->
<div class="modal-header">
  <h4 class="modal-title">Documento</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    x
  </button>
</div>
<div class="modal-body taskboard-modal">
  <div class="container">
    <form [formGroup]="form" (ngSubmit)="save()" novalidate>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-12 mb-1">
                    <fieldset class="form-group">
                      <label for="txtDepartment">Departamento*</label>
                      <ng-select id="txtDepartment" [items]="listDeps" bindLabel="name" [multiple]="false" [(ngModel)]="doc.department"
                                 formControlName="department" [closeOnSelect]="true" placeholder="Selecione" class="width-300 mr-4"
                                 (change)="filterDepUpdate($event)" >
                      </ng-select>
                      <small class="form-text text-muted danger"
                             *ngIf="!form.get('department').valid && (form.get('department').dirty || form.get('department').touched)">Campo
                        Obrigatório</small>
                    </fieldset>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-12 mb-1">
                    <fieldset class="form-group">
                      <label for="txtType">Tipo*</label>
                      <ng-select id="txtType" [items]="selDep['types']" [multiple]="false" [(ngModel)]="doc.type"
                                 formControlName="type" [closeOnSelect]="true" placeholder="Selecione" class="width-300 mr-4">
                      </ng-select>
                      <small class="form-text text-muted danger"
                             *ngIf="!form.get('type').valid && (form.get('type').dirty || form.get('type').touched)">Campo
                        Obrigatório</small>
                    </fieldset>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-12 mb-1">
                    <fieldset class="form-group">
                      <label for="txtCompetence">Competência</label>
                      <ng-select id="txtCompetence" [items]="competences" [multiple]="false" [(ngModel)]="doc.competence"
                                 formControlName="competence" [closeOnSelect]="true" placeholder="Selecione" class="width-300 mr-4">
                      </ng-select>
                    </fieldset>
                  </div>
                </div>
                <div class="row">

                  <div class="col-xl-6 col-lg-6 col-md-12 mb-1">
                    <label for="txtDate">Data de Documento*</label>
                    <input id="txtDate" class="form-control" type="date" [(ngModel)]="doc.date" formControlName="date"/>
                    <small class="form-text text-muted danger"
                           *ngIf="!form.get('date').valid && (form.get('date').dirty || form.get('date').touched)">Campo
                      Obrigatório</small>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-12 mb-1">
                    <label for="txtExpireDate">Data de Validade*</label>
                    <input id="txtExpireDate" class="form-control" type="date" [(ngModel)]="doc.expireDate" formControlName="expireDate"/>
                    <small class="form-text text-muted danger"
                           *ngIf="!form.get('expireDate').valid && (form.get('expireDate').dirty || form.get('expireDate').touched)">Campo
                      Obrigatório</small>
                  </div>
                </div>
                <div class="row">

                  <div class="col-xl-12 col-lg-12 col-md-12 mb-1" *ngIf="doc.id == null && doc.url == null">
                    <div class="card-body ">
                      <div class="col-md-12" *ngIf="fileName != null">
                        {{fileName}}
                        <br>
                        <br>
                        <a (click)="removeAtt()">Remover</a>
                      </div>
                      <div ng2FileDrop *ngIf="fileName == null"
                           [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
                           (fileOver)="fileOverBase($event)" (click)="fileChange($event, 0)"
                           [uploader]="uploader"
                           class=" py-5 mb-3 text-center font-medium-5 grey my-drop-zone">
                        Arraste o documento aqui
                      </div>
                      <input ng2FileSelect type="file" id="uploadPDF" #takeInput
                             class="file form-control-file file-hide" [uploader]="uploader"/>
                    </div>
                  </div>

                  <div class="col-xl-12 col-lg-12 col-md-12 mb-1" *ngIf="doc.id != null && (doc.url === undefined || doc.url === null)">
                    <div class="card-body ">
                      <div class="col-md-12" *ngIf="fileName != null">
                        {{fileName}}
                        <br>
                        <br>
                        <a (click)="removeAtt()">Remover</a>
                      </div>
                      <div ng2FileDrop *ngIf="fileName == null"
                           [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
                           (fileOver)="fileOverBase($event)" (click)="fileChange($event, 0)"
                           [uploader]="uploader"
                           class=" py-5 mb-3 text-center font-medium-5 grey my-drop-zone">
                        Arraste o documento aqui
                      </div>
                      <input ng2FileSelect type="file" id="uploadPDF" #takeInput
                             class="file form-control-file file-hide" [uploader]="uploader"/>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button type="submit" class="btn btn-raised btn-primary mt-3">salvar&nbsp;<i
                class="ft-thumbs-up position-right"></i></button>
      </div>
    </form>
  </div>
</div>
